const STEP_DATA_GRADE_10 = [
  {title: 'Chọn cơ sở', key: 'choose-department', step: 1},
  {title: 'Thông tin người giám hộ', key: 'fill-info', step: 2},
  {title: 'Thông tin học sinh', key: 'study-result', step: 3},
  {title: 'Khai báo diện tuyển thẳng', key: 'register-expectation', step: 4},
  {title: 'Tổ hợp môn học tự chọn', key: 'register-group-expectation', step: 5},
  {title: 'Kết quả kỳ thi tuyển sinh vào Lớp 10', key: 'exam-result', step: 6},
]
const LIST_USER_PROD = [
  '6405ac8fe86dad2ffb0346d2',
  '6405a73ae86dad2ffb0346c9',
  '6405ac12e86dad2ffb0346cf',
  '65a0f59b2365e764e9c501e3',
  '67a96a78c0b314af8bc7c294',
  '6939266fa2591d611f68f307',
  '67a70a1a5dca5a9a35bd5f8c',
  '693a994c4c67d8b746503143',
  '693a99634c67d8b746503144',
  '659fb7652365e764e9c50043',
]
const LIST_USER_DEV = ['6412da5d9b5cb29506e5758a', '67a96a78c0b314af8bc7c294']
//process.env.NODE_ENV === 'development'
const ALLOWED_UPDATE = process.env.NODE_ENV === 'development' ? LIST_USER_DEV : LIST_USER_PROD
const ALLOWED_VIEW_DETAIL_TRANS_SCHOLARSHIP = [
  '67a96a78c0b314af8bc7c294',
  '6405ac8fe86dad2ffb0346d2',
  '65a0f59b2365e764e9c501e3',
]
const ALLOWED_VIEW_ADS_POPUP = ['annvh', 'anhvn', 'annv', 'quynhdv']
const ALLOWED_VIEW_EVENTS = ['annvh', 'annv', 'quynhdv']
const ALLOWED_ASSIGN_CLASS = ['linhnt', 'ngaltt', 'trungkd', 'uyenpt']
const ALLOWED_SETTING_ENROLL_PLAN = ['annv', 'quynhdv', 'annvh']
const DEPARMENT_DICT = {'Cơ sở A': 'Cầu Giấy', 'Cơ sở 1': 'Tân Triều'}
const CV_DEADLINE_TYPE = {RESULT_FILL: 'result-fill', UPDATE: 'update', CREATE: 'create'}

export default {
  STEP_DATA_GRADE_10,
  ALLOWED_UPDATE,
  ALLOWED_VIEW_DETAIL_TRANS_SCHOLARSHIP,
  ALLOWED_VIEW_ADS_POPUP,
  ALLOWED_VIEW_EVENTS,
  ALLOWED_ASSIGN_CLASS,
  ALLOWED_SETTING_ENROLL_PLAN,
  DEPARMENT_DICT,
  CV_DEADLINE_TYPE,
}
